import "./Techs.css";
function Techs() {
	const techs = [
		{
			name: "JavaScript",
			image: "/assets/JavaScript.svg",
			link: "https://simple.wikipedia.org/wiki/JavaScript",
			alt: "JavaScript Logo",
		},
		{
			name: "TypeScript",
			image: "/assets/TypeScript.svg",
			link: "https://www.typescriptlang.org/",
			alt: "TypeScript Logo",
		},
		{
			name: "Node.js",
			image: "/assets/Node.js.svg",
			link: "https://nodejs.org/en",
			alt: "Node.js Logo",
		},
		{
			name: "Next.js",
			image: "/assets/Next.js.svg",
			link: "https://nextjs.org/",
			alt: "Next.js Logo",
		},
		{
			name: "Nest.js",
			image: "/assets/Nest.js.svg",
			link: "https://nestjs.com/",
			alt: "Nest.js Logo",
		},
		{
			name: "Fastify",
			image: "/assets/Fastify.svg",
			link: "https://fastify.dev/",
			alt: "Fastify Logo",
		},
		{
			name: "C++",
			image: "/assets/C++ (CPlusPlus).svg",
			link: "https://en.wikipedia.org/wiki/C%2B%2B",
			alt: "C++ Logo",
		},
		{
			name: "C#",
			image: "/assets/CSharp.svg",
			link: "https://learn.microsoft.com/pt-br/dotnet/csharp/",
			alt: "C# Logo",
		},
		{
			name: ".NET Core",
			image: "/assets/NET core.svg",
			link: "https://dotnet.microsoft.com/en-us/",
			alt: ".NET Core Logo",
		},
		{
			name: "Java",
			image: "/assets/Java.svg",
			link: "https://www.java.com/en/",
			alt: "Java Logo",
		},
		{
			name: "Spring",
			image: "/assets/Spring.svg",
			link: "https://spring.io/",
			alt: "Spring Logo",
		},
		{
			name: "PostgreSQL",
			image: "/assets/PostgresSQL.svg",
			link: "https://www.postgresql.org/",
			alt: "PostgreSQL Logo",
		},
	];

	return (
		<section id="techs" className="bg-700-fade">
			<div className="h-100 mt-5 px-sm-5">
				<div className="w-100 py-3 color-200">
					<h2 className="fs-2">Tecnologias</h2>
					<p className="color-600 fs-5">
						Aqui estão algumas das tecnologias que eu uso no meu dia a dia.
					</p>
				</div>
			</div>
			<div className="p-sm-5 mx-1">
				<div className="px-3 row">
					{techs.map((tech, index) => (
						<div
							className={`col-3 text-${
								index < 4 || index > 7 ? "center" : "start"
							} `}
							key={tech.name}
						>
							<a href={tech.link} target="_blank" rel="noopener noreferrer">
								<img
									src={tech.image}
									className="img-fluid bg-700 p-3 rounded scale"
									alt={tech.alt}
									width={index < 4 || index > 7 ? "90px" : "100px"}
								/>
							</a>
							{index % 4 === 0 && <div className="col-12 py-3"></div>}
						</div>
					))}
				</div>
			</div>
		</section>
	);
}

export default Techs;
